import { ROLES } from "./roles";

export const menuByRole = {

    [ROLES.SELLER]: [
        {
            path: "/dashboard",
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            section: "main"
        },

        {
            path: "/instant-request",
            icon: "fas fa-bolt",
            label: "Instant Request",
            section: "pages"
        },
        {
            path: "/my-offers",
            icon: "fas fa-percent",
            label: "My Offers",
            section: "pages"
        },

        {
            label: "Orders",
            icon: "fas fa-shopping-cart",
            section: "pages",
            children: [
                { path: "/orders", label: "My Orders" },
                { path: "/orders/pending", label: "Pending Orders" },
                { path: "/orders/completed", label: "Completed Orders" }
            ]
        },

        // {
        //     path: "/inventory",
        //     icon: "fas fa-warehouse",
        //     label: "Inventory",
        //     section: "pages"
        // },

        // {
        //     path: "/shipments",
        //     icon: "fas fa-truck",
        //     label: "Shipments",
        //     section: "pages"
        // }
    ],

    [ROLES.BUYER]: [
        {
            path: "/dashboard",
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            section: "main"
        },

        {
            path: "/search-material",
            icon: "fas fa-search",
            label: "Search Material",
            section: "pages"
        },

        {
            path: "/orders",
            icon: "fas fa-shopping-cart",
            label: "Orders",
            section: "pages"
        }
    ],

    [ROLES.FREIGHT]: [
        {
            path: "/dashboard",
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            section: "main"
        },

        {
            path: "/shipments",
            icon: "fas fa-truck",
            label: "Active Shipments",
            section: "pages"
        },

        {
            path: "/my-trucks",
            icon: "fas fa-truck-loading",
            label: "My Trucks",
            section: "pages"
        }
    ],

    [ROLES.ADMIN]: [
        {
            path: "/dashboard",
            icon: "fas fa-tachometer-alt",
            label: "Dashboard",
            section: "main"
        },

        {
            path: "/team-management",
            icon: "fas fa-users",
            label: "Team Management",
            section: "pages"
        },

        {
            path: "/account",
            icon: "fas fa-user-cog",
            label: "Admin Account",
            section: "pages"
        }
    ]

};